import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import { thousandSeparator, checkAuthorization } from "../utils/utils";
import moment from "moment";

const { Select2, Date, DateTime, Text } = Inputs;

function InvitacionesList({ history, match }) {
  const dispatch = useDispatch();

  const modelInvitaciones = useSelector(
    (state) => state.getInvitaciones
  );

  const [invitaciones, setInvitaciones] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const data = modelInvitaciones?.data?.data;
    const error = modelInvitaciones?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckGetInvitaciones.actions.clear());
    }
    if (data) {
      setInvitaciones(data.data.items);
      setTotalResults(data.data.total);

      dispatch(controller.duckGetInvitaciones.actions.clear());
    }
  }, [modelInvitaciones]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      history.push("/logout");
    }
    dispatch(controller.getInvitacionesThunk(token, 1, 10));
  }, []);

  function handlePage(page) {
  
    setActivePage(page);
    const token = localStorage.getItem("token");
    setInvitaciones([]);
    dispatch(controller.getInvitacionesThunk(token, page + 1, pageSize));
  }

  return (
    <Content
      title="Mis invitaciones"
      subTitle="Autosweb invitaciones"
      browserTitle="Mis invitaciones"
      show={false}
    >
      <Row>
        <Col md="10" mdOffset="1">
          <Box title="Invitaciones">
          <Button
              type="primary"
              text="Agregar"
              pullRight={true}
              onClick={() => history.push(`/crearInvitacion`)}
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
            {invitaciones && invitaciones.length > 0 ? (
              <SimpleTable
              hover={true}
                data={invitaciones.map((row, index) => {
                  return {
                    email: row.email,
                    telefono: row.phone,
                    rol: row.rol,
                    creado: moment(row.tsCreated).format("DD-MM-YYYY"),
                    utilizado: moment(row.tsCreated).format("DD-MM-YYYY"),

                  };
                })}
                columns={[
                  { title: "Correo", data: "email" },
                  { title: "Telefono", data: "telefono" },
                  { title: "Rol", data: "rol" },
                  { title: "Creado", data: "creado" },
                  { title: "Utilizado", data: "utilizado" },
                
                ]}
              />
            ) : (
              <h4>No se han encontrado publicaciones</h4>
            )}
            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels= {{
                first: 'Primera',
                last: 'Última',
                previous: 'Anterior',
                next: 'Siguiente',
              }}              
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default InvitacionesList;
